<template>
  <section class="h_10">
    <m-img src="@/v2/mobile/assets/image/h_10.jpg"></m-img>
  </section>
</template>
<script>
export default {
  name: 'Weather',

  methods: {},

  mounted() {},
}
</script>

<style lang="less" scoped>
.h_10 {
  position: relative;
  overflow: hidden;
}
</style>
